// Utility function to convert numbers to Persian
export const toPersianNumbers = (num: string | number): string => {
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return num.toString().replace(/\d/g, (digit) => persianDigits[parseInt(digit)]);
};

// Utility function to format price
export const formatPrice = (price: string | number): string => {
  if (!price) return '';
  
  // Extract numeric value from price string (remove any non-numeric chars except digits and dots)
  let numericPrice = price.toString().replace(/[^\d.]/g, '');
  
  // Parse as number and format with thousand separators
  const number = parseFloat(numericPrice);
  if (isNaN(number)) return price.toString();
  
  // Format with commas
  const formatted = number.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  
  // Convert to Persian numbers and add تومان
  return toPersianNumbers(formatted) + ' تومان';
};

